// extracted by mini-css-extract-plugin
export default {"dataVolumeWrapper":"deviceStatus_dataVolumeWrapper__oriOj","dataVolume":"deviceStatus_dataVolume__Vgn3l","dataVolumeUsed":"deviceStatus_dataVolumeUsed__l5Gc6"};